export default __webpack_public_path__ + "static/media/63t.4513156f.jpg";